import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat'
})

export class DateFormatPipe implements PipeTransform {

  transform(value: string | Date): string {
    if(!value) return ""

    if (value instanceof Date) {
      return value.toISOString().replace("T", " ").split(".")[0];
  }

    var date = value.split("T")
    return  date[0] + " " + date[1].split(".")[0]
  }

}
